export default __webpack_public_path__ + "static/land-tier-5-7c11c4529c2d8fc88b8d158e67c2bbfc.png";